import { useTheme } from 'hooks/useTheme';
import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { verifyCaptcha } from 'utils/api';
import { captchaConfig } from 'utils/constants';

interface Props {
  setToken: (token: string | null) => void;
}

export default function Captcha({ setToken }: Props) {
  const theme = useTheme();
  const onReCaptchaCallback = async (token: string | null) => {
    if (!token) {
      return;
    }

    await verifyCaptcha(token, (token: string | null) => {
      setToken(token);
    });
  };

  const onReCaptchaErrorOrExpired = () => {
    setToken(null);
  };

  return (
    <ReCAPTCHA
      onChange={onReCaptchaCallback}
      onErrored={onReCaptchaErrorOrExpired}
      onExpired={onReCaptchaErrorOrExpired}
      sitekey={captchaConfig.siteKey || ''}
      theme={theme}
    />
  );
}
